window.Adult = {
	run: function () {
		if (!this.isShow()) {
			this.show();
		}
	},

	show: function () {
		$('body').addClass('showModalAdult');
		$("#modal-adults").modal('show');
	},

	isShow: function() {
		return !!Cookie.get('adult');
	},

	setShow: function () {
		Cookie.set('adult', true, {
			expires: 60*60*24*14,
		});
	}
};

$('[data-dismiss="site"]').click(function () {
	window.close();
});

$("#modal-adults").find('[data-dismiss="modal"]').click(function () {
	if (!Adult.isShow()) {
		Adult.setShow();
	}
});

$('#modal-adults').on('hidden.bs.modal', function () {
	$('body').removeClass('showModalAdult');
});